export enum themeActionType {
  SET_THEME = 'SET_THEME',
  SET_LOGO = 'SET_LOGO',
}
